<template>
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
    <h3 class="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4">
      {{ label }}
    </h3>
    <p class="text-gray-500 dark:text-gray-400">This step is coming soon.</p>
  </div>
</template>

<script setup>
const props = defineProps({
  stepKey: { type: String, required: true },
  label: { type: String, required: true },
  onboarding: { type: Object, required: true },
  mode: { type: String, required: true }
})

defineExpose({
  getData: () => ({})
})
</script>
